import { Image } from '@chakra-ui/react';
import { ADVISOR_PANEL_PRIMARY_500, ADVISOR_SIDE_PANEL_Z_INDEX } from '@kintsugi/advisor-ui';
import { Button, Tooltip } from '@kintsugi/ui';
import type { ReactNode } from 'react';

import { useAdminAgent } from './use-admin-agent';
import { KIN_SIDE_TAB_BUTTON_URL } from './kin-icons';

const SIDE_TAB_Z = ADVISOR_SIDE_PANEL_Z_INDEX - 1;

export function AdminAgentSideTab(): ReactNode {
  const { eligible, open, openDrawer } = useAdminAgent();

  if (!eligible || open) {
    return null;
  }

  return (
    <Tooltip content="Open Kin" positioning={{ placement: 'left' }} showArrow>
      <Button
        size="md"
        type="button"
        variant="plain"
        aria-label="Open Kin"
        onClick={() => openDrawer()}
        position="fixed"
        right={0}
        top="50%"
        transform="translateY(-50%)"
        zIndex={SIDE_TAB_Z}
        w="62px"
        minW="62px"
        h="146px"
        p={0}
        cursor="pointer"
        bg="transparent"
        borderRadius={0}
        transition="filter 0.15s ease"
        display="flex"
        alignItems="center"
        justifyContent="center"
        _hover={{ filter: 'brightness(0.96)' }}
        _focusVisible={{
          outline: '2px solid',
          outlineColor: ADVISOR_PANEL_PRIMARY_500,
          outlineOffset: '2px',
        }}
      >
        <Image src={KIN_SIDE_TAB_BUTTON_URL} alt="" w="62px" h="146px" draggable={false} aria-hidden />
      </Button>
    </Tooltip>
  );
}
